import React, { FC, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import DropHint from 'components/shell/DropHint';

/**
 * Gallery: a drop area on the left, the images on the right. UI refresh styling (5 Nov 2026):
 * the shared dashed drop hint and a light divider. On a phone the drop area sits above the images.
 */

type Props = {
  upload(file: File): void;
  allowClick?: boolean;
};

const GalleryDropzone: FC<Props> = ({ upload, children, allowClick = false }) => {
  const onDrop = useCallback(
    (acceptedFiles: []) => {
      acceptedFiles.forEach((file) => {
        upload(file);
      });
    },
    [upload],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted: onDrop,
    multiple: true,
    noClick: !allowClick,
  });

  return (
    <div className="archy-gallery" style={{ display: 'flex', width: '100%', height: '100%', overflow: 'hidden', paddingBottom: 12, boxSizing: 'border-box' }}>
      <div
        {...getRootProps()}
        className="archy-gallery-drop"
        style={{ position: 'relative', flex: '0 0 32%', minHeight: 160, outline: 'none', borderRight: '1px solid #EEF0F2' }}
      >
        <DropHint text="Drop images here to add them to the gallery" active={isDragActive} />
        <input {...getInputProps()} />
      </div>
      <div className="archy-gallery-list" style={{ flex: 1, minWidth: 0, height: '100%', overflow: 'auto', background: '#FFFFFF', padding: 8, boxSizing: 'border-box' }}>
        {children}
      </div>
    </div>
  );
};

export default GalleryDropzone;
